import {Grid} from "@material-ui/core";
import * as PropTypes from "prop-types";
import React, {useEffect, useState} from "react";
import {createCalculatedColumn, createColumn, createComponentColumn} from "../../../utils/ColumnUtils";
import EAButton from "../../EAButton";
import EAButtonBar from "../../EAButtonBar";
import EADialog from "../../EADialog";
import EATable from "../../EATable";
import EATextField from "../../EATextField";
import EATableActionButton from "../../tableComponents/EATableActionButton";
import {logger} from "../../../services/LogService";
import {getAbwasserbeseitigungspflichtigeEndpointIncludeHistory} from "../../../services/OrganisationsService";
import {useHttpSortById} from "../../../utils/usePreformattedHttp";
import {getMoeglicheAufnehmendeAnlagen} from "../../../services/AnlagenService";
import AbwasserbeseitigungspflichtigeDialog from "./AbwasserbeseitigungspflichtigeDialog";

export function AufnahmeTableDialog(props) {
    let [{data, loading}] = useHttpSortById({
        url: getMoeglicheAufnehmendeAnlagen(props.betriebsId, props.anlagentyp),
        timeout: 600000,
    });
    const [filteredData, setFilteredData] = useState([]);
    const [filter, setFilter] = useState("");

    useEffect(() => {
        if (data) {
            setFilteredData([
                ...data.filter((item) => {
                    return (
                        item.id !== props.anlageId &&
                        (!filter ||
                            item.betrieb.value.toLowerCase().includes(filter.toLowerCase()) ||
                            item.bezeichnung.toLowerCase().includes(filter.toLowerCase()))
                    );
                }),
            ]);
        }
    }, [data, props.anlageId, filter, loading]);

    return (
        <EADialog
            open={props.open}
            titleChildren={"Aufnehmende Anlage auswählen"}
            content={
                <div style={{width: "700px", maxHeight: "520px", minHeight: "400px"}}>
                    <div className="gridl" style={{gridTemplateColumns: "repeat(3,auto)", paddingBottom: "8px"}}>
                        <EATextField
                            value={filter}
                            onChange={(e) => {
                                e.preventDefault();
                                setFilter(e.target.value);
                            }}
                            id="aufnahmeFilter"
                            data-cy="aufnahmeFilter"
                            label="Suchkriterium"
                        />
                        <div>
                            <EAButton
                                onClick={() => {
                                    setFilter("");
                                }}
                                id="aufnahmeFilterSucheReset"
                                data-cy="aufnahmeFilterSucheReset"
                                label="Zurücksetzen"
                            />
                        </div>
                    </div>
                    <EATable
                        id="aufnahmeAuswahl"
                        initialSortColumn="mipNr"
                        columns={[
                            createComponentColumn(
                                "actions",
                                (row, index) => {
                                    return (
                                        <Grid container spacing={1} justify="center">
                                            <Grid item>
                                                <EATableActionButton id={"selectAufnahme-" + index} iconName="ico-check">
                                                    <span
                                                        onClick={() => {
                                                            setFilter("");
                                                            props.onClickOk(row);
                                                        }}
                                                        className={"w-100"}
                                                        style={{
                                                            height: "100%",
                                                            display: "block",
                                                        }}
                                                    />
                                                </EATableActionButton>
                                            </Grid>
                                        </Grid>
                                    );
                                },
                                "",
                                null,
                                {width: "50px", padding: "0"}
                            ),
                            createCalculatedColumn(
                                "betrieb",
                                (row) => {
                                    return row.betrieb.value;
                                },
                                "Betrieb"
                            ),
                            createColumn("bezeichnung", "Abwasseranlage"),
                        ]}
                        data={filteredData}
                        loading={loading}
                    />
                </div>
            }
            buttons={
                <EAButtonBar>
                    <EAButton id={"btnAbbrechen"} data-cy={"btnAbbrechen"} label={"Abbrechen"} onClick={props.onClickCancel}/>
                </EAButtonBar>
            }
            closeFunction={props.onClickCancel}
        />
    );
}

AufnahmeTableDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClickCancel: PropTypes.func.isRequired,
    onClickOk: PropTypes.func.isRequired,
};

export function AnlagenEinleiter({
                                     abwasserbeseitigungspflichtige,
                                     onChange,
                                     betriebsId,
                                     anlageId,
                                     anlagentyp,
                                     formFactory,
                                     indirekteinleiter,
                                     isButtonVisible,
                                     isIndirektDisabled,
                                     disabled
                                 }) {
    const dataName = "aufnahme";
    const [orgaOptions] = useHttpSortById(getAbwasserbeseitigungspflichtigeEndpointIncludeHistory);
    const [dlgOpen, setDlgOpen] = useState(false);
    const [abwasserbeseitigungspflichtigeDialogOpen, setAbwasserbeseitigungspflichtigeDialogOpen] = useState(false);

    const calculateCurrentAbwasserbeseitigungspflichtiger = (items) => {
        if (!items) {
            return "";
        } else {
            const startJahre = items.map(item => item.startJahr);
            const mostRecentStartJahr = Math.max(...startJahre);
            const filteredAbwasserbeseitigungspflichtiger = items.filter(item => item.startJahr === mostRecentStartJahr);

            if (filteredAbwasserbeseitigungspflichtiger.length > 0) {
                return filteredAbwasserbeseitigungspflichtiger[0].organisation?.bezeichnung ? filteredAbwasserbeseitigungspflichtiger[0].organisation.bezeichnung : filteredAbwasserbeseitigungspflichtiger[0].organisation.value;
            } else {
                return "";
            }
        }
    };

    function handleClose() {
        setDlgOpen(false);
    }

    function handleCloseOk(anlage) {
        setDlgOpen(false);
        logger.debug(dataName + "Close", anlage);
        anlage.value = anlage.bezeichnung;
        onChange(dataName, anlage);
    }

    return (
        <>
            {dlgOpen && (
                <AufnahmeTableDialog
                    open={dlgOpen}
                    onClickCancel={handleClose}
                    onClickOk={handleCloseOk}
                    betriebsId={betriebsId}
                    anlageId={anlageId}
                    anlagentyp={anlagentyp}
                />
            )}
            <div className="gridl gridForAnlagenEinleiter" style={{padding: "var(--vertical-spacing) 0 0"}}>
                {formFactory.renderCheckbox(
                    "indirekteinleiter",
                    "indirekteinleiter",
                    "Indirekteinleiter",
                    isIndirektDisabled || disabled,
                    null,
                    [
                        {
                            id: "aufnahme",
                            calcDependentVal: () => {
                                return null;
                            },
                        }
                    ]
                )}
                <div style={{gridColumn: "2/span 4"}}>
                    {!indirekteinleiter || (
                        <div className="gridl" style={{gridTemplateColumns: "1fr auto"}}>
                            {formFactory.renderInput("aufnahme.value", "aufnahme.value", "Aufnehmende Anlage", "text", true)}
                            {isButtonVisible &&
                                formFactory.renderButton("aufnameAendern", "aufnameAendern", "auswählen...", () => setDlgOpen(true), {
                                    "data-cy": "aufnameAendern",
                                    disabled: !indirekteinleiter,
                                })}
                            {formFactory.renderError("aufnahme", "aufnahme", "", "Es muss eine aufnehmende Anlage ausgewählt werden")}
                        </div>
                    )}
                </div>
                {!isIndirektDisabled && !indirekteinleiter &&
                    <div className="gridl" style={{gridTemplateColumns: "1fr auto"}}>
                        {formFactory.renderInputWithCustomDisplay("abwasserbeseitigungspflichtige", "abwasserbeseitigungspflichtige", "Abwasserbeseitigungspflichtiger", calculateCurrentAbwasserbeseitigungspflichtiger, true)}
                        <EAButton id="edit-abwasserbeseitigungspflichtiger-button"
                                  label={disabled ? "Übersicht... " : "Auswählen..."}
                                  onClick={() => setAbwasserbeseitigungspflichtigeDialogOpen(true)}
                        />
                    </div>
                }
            </div>
            <AbwasserbeseitigungspflichtigeDialog open={abwasserbeseitigungspflichtigeDialogOpen}
                                                  readonly={disabled}
                                                  selectableAbwasserbeseitigungspflichtige={orgaOptions.loading ? [] : orgaOptions.data}
                                                  veranlagungen={abwasserbeseitigungspflichtige}
                                                  anlageId={anlageId}
                                                  onClose={(newCurrentAbwasserbeseitigungspflichtiger, newVeranlagungen) => {
                                                      onChange("abwasserbeseitigungspflichtige", newVeranlagungen);
                                                      setAbwasserbeseitigungspflichtigeDialogOpen(false);
                                                  }}
            />
        </>
    );
}

AnlagenEinleiter.propTypes = {
    betriebsId: PropTypes.any.isRequired,
    anlagentyp: PropTypes.string.isRequired,
    formFactory: PropTypes.any.isRequired,
    disabled: PropTypes.any.isRequired,
    isButtonVisible: PropTypes.bool.isRequired,
    isIndirektDisabled: PropTypes.bool,
    indirekteinleiter: PropTypes.bool,
};
